import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchInput from "./SearchInput";
import LabelText from "./LabelText";
import { Iteams } from "../types/IOption";
import CustomizedTooltips from "./Tooltip";

interface DropDownListProps {
  optionsLength: number;
}

const DropDownContainer = styled.div`
  display: grid;
  gap: 8px;
  width: 100%;
  position: absolute;
`;

const InputFeild = styled.div`
  display: flex;
  padding: 8px 8px 8px 12px;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 4px;
  cursor: pointer;
`;

const InputHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  .arrow-icon {
    color: ${({ theme }) => theme.playerColor};
  }
  cursor: pointer;

`;

const InputTitle = styled.span<CustomDropdownProps>`
  display: flex;
  color: ${({ theme }) => theme.NumberColor};
  cursor: pointer;
  gap: ${({ fromPlayingstat }) => (fromPlayingstat ? "0px" : "12px")};
`;



const DropDownListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  padding: 4px 4px 8px 4px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
  background: ${({ theme }) => theme.secondaryButtonBackground};
  box-shadow: ${({ theme }) => theme.boxShadow};
  z-index: 9999;
`;

const DropDownList = styled.div<DropDownListProps>`
  overflow-y: ${({ optionsLength }) => (optionsLength > 5 ? "scroll" : "visible")};
  max-height: ${({ optionsLength }) => (optionsLength > 5 ? "300px" : "auto")};
  width: 100%;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: transparent;
    background-color: #f5f5f5;
    position: fixed;
    top: 0px;
    right: 10px;
    bottom: 0px;
  }
  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
    position: fixed;
    top: 0px;
    right: 10px;
    bottom: 0px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bebebe;
    border-radius: 10px;
    position: fixed;
    top: 0px;
    right: 10px;
    bottom: 0px;
  }
`;

// const ListItem = styled.div<{ isSelected: boolean; index?: number }>
//   `display: flex;
//   justify-content: space-between;
//   height: 48px;
//   padding: 8px 12px;
//   gap: 14px;
//   align-self: stretch;
//   border-radius: 2px;
//   background: ${({ theme, isSelected, index }) =>
//     isSelected ? theme.dropdownBorderColor : index && (index === 0 || index % 2 !== 0) ? "#F9FAF7" : theme.secondaryButtonBackground};
//   color: ${({ theme }) => theme.playerColor};
//   font-feature-settings: "clig" off, "liga" off;
//   align-items: center;
//   font-family: "Aeonik";
//   font-size: 20px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 20px;
//   cursor: pointer;

//   &:hover {
//     border-radius: 2px;
//     background: ${({ theme }) => theme.dropdownBorderColor};
//   }`
//   ;
const ListItem = styled.div<{ isSelected: boolean; disabled?: boolean; index?: number }>`
  display: flex;
  justify-content: space-between;
  height: 48px;
  padding: 8px 12px;
  gap: 14px;
  align-self: stretch;
  border-radius: 2px;
  background: ${({ theme, isSelected, index }) =>
    isSelected ? theme.dropdownBorderColor : index && (index === 0 || index % 2 !== 0) ? "#F9FAF7" : theme.secondaryButtonBackground};
  color: ${({ theme, disabled }) => (disabled ? "#aaa" : theme.playerColor)};
  font-feature-settings: "clig" off, "liga" off;
  align-items: center;
  font-family: "Aeonik";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: ${({ disabled }) => (disabled ? "none" : "pointer")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  &:hover {
    border-radius: 2px;
    background: ${({ theme, disabled }) => (disabled ? "none" : theme.dropdownBorderColor)};
  }
`;

interface CustomDropdownProps {
  options?: any[];
  value?: string;
  onChange?: (value: string, clubId?: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  onClick?: () => void; // Add onClick to the interface
  isDisplaySearchInput?: boolean;
  deafaultSelected?: string;
  currentLogo?: string[];
  className?: string;
  fromAttributes?: boolean;
  fromPlayingstat?: boolean;
  dishabled?: boolean;
  Id? : number
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  onChange,
  placeholder,
  disabled,
  isDisplaySearchInput = true,
  deafaultSelected,
  currentLogo,
  className,
  fromAttributes,
  fromPlayingstat,
  dishabled,
  Id
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string | null>();
  const [filteredOptions, setFilteredOptions] = useState(options);

  const toggling = (): void => setIsOpen(!isOpen);

  // const onOptionClicked = (value: string) => (): void => {
  //   setSelectedOption(value);
  //   // if(value === '0'){
  //   //   setSelectedOption('Career')
  //   // }
  //   setIsOpen(false);
  //   if (onChange) onChange(value);
  // };

  // const onOptionClicked = (value: string, disabled?: boolean) => (): void => {
  //   if (disabled) return;
  //   setSelectedOption(value);
  //   setIsOpen(false);
  //   if (onChange) onChange(value);
  // };

  const onOptionClicked = (value: string, disabled?: boolean) => (): void => {
  if (disabled) return;
  setSelectedOption(value);
  setIsOpen(false);

  const selected = options?.find((option) => option.value === value);
  const teamId = selected?.teams?.[0]?.teamId; // pick first teamId or adjust as needed

  if (onChange) onChange(value, teamId);
};

  // useEffect(() => {
  //   setSelectedOption("");
  // }, [deafaultSelected, options]);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const filtered = options?.filter((option) => option.label.toLowerCase().includes(value.toLowerCase()));
    setFilteredOptions(filtered);
  };

  const handleClear = () => {
    setFilteredOptions(options);
  };

  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

  //   <LabelText className="player-given-name">
  //     {selectedOption
  //       ? options.find((option) => option.value === selectedOption)?.label
  //       : deafaultSelected}
  //   </LabelText>
  // </div>

  useEffect(()=>{
    if(Id! > 0){
        setSelectedOption("")
    }
  },[Id!])

  return (
    <DropDownContainer className={className} ref={dropdownRef}>
      <InputFeild onClick={toggling} className="club-nav-header">
        <InputHeader>
          <InputTitle fromPlayingstat={fromPlayingstat}>
            {placeholder !== undefined && <LabelText>{`${placeholder} `}</LabelText>}
            <LabelText className="player-given-name">
              {selectedOption ? options?.find((option) => option.value === selectedOption)?.label  : deafaultSelected}
            </LabelText>
            {/* <LabelText className="player-given-name">
              {selectedOption
                ? options?.find((option) => option.value === selectedOption)?.label
                : deafaultSelected}
            </LabelText> */}
          </InputTitle>
          {isOpen ? (
            <KeyboardArrowUpIcon sx={{ fontSize: "24px" }} className="arrow-icon" />
          ) : (
            <KeyboardArrowDownIcon sx={{ fontSize: "24px" }} className="arrow-icon" />
          )}
        </InputHeader>
        {selectedOption && (fromAttributes || fromPlayingstat) ? (
          options
            ?.find((option) => option.value === selectedOption)
            ?.teams?.map((team: any, index: number, arr: any) => (
              <div key={team.teamId} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
               <img
                  src={team.teamLogoURL}
                  alt={team.teamName}
                  width="25"
                  height="25"
                  style={{ borderRadius: "5px" }}
                />
                {index < arr.length - 1 && <span>/</span>}
              </div>
            ))
        ) : (
          // fallback to default image
          deafaultSelected !== 'Career' && currentLogo?.map((team: any, index: number, arr: any) => (
            <div key={team.teamId} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <img
                src={team}
                width="25"
                height="25"
                style={{ borderRadius: "5px" }}
              />
              {index < arr.length - 1 && <span>/</span>}
            </div>
          ))
        )}
      </InputFeild>
      {isOpen && (
        <DropDownListContainer className="custom-option">
          <DropDownList optionsLength={options?.length || 0}>
            {isDisplaySearchInput && <ListItem isSelected={!selectedOption}>{placeholder}</ListItem>}
            {isDisplaySearchInput && <SearchInput handleSearch={handleSearch} handleClear={handleClear} />}
            {!isDisplaySearchInput && placeholder && <p className="menu-placeholder-only">{placeholder}</p>}

            {filteredOptions?.map((option, index) => (
              <ListItem
                index={index}
                key={option.value}
                isSelected={selectedOption === option.value}
                disabled={option.disabled}
               onClick={onOptionClicked(option.value, option.disabled)}
              >
                {option.label}
                {(fromAttributes || fromPlayingstat) && (
                  <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                    {option.teams.map((team: Iteams, index: number) => (
                      <>
                        <CustomizedTooltips title={team.teamName}>
                          <img
                            key={team.teamId}
                            src={team.teamLogoURL}
                            alt={team.teamName}
                            width="25"
                            height="25"
                            style={{ borderRadius: "5px" }}
                          />
                        </CustomizedTooltips>
                        {index < option.teams.length - 1 && <span>/</span>}
                      </>
                    ))}
                  </div>
                )}
              </ListItem>
            ))}
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
};

export default CustomDropdown;
